import { Component, OnInit, Input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'nwt-power-supply-tooltip',
  templateUrl: './power-supply-tooltip.component.html',
  styleUrls: ['./power-supply-tooltip.component.scss']
})
export class PowerSupplyTooltipComponent implements OnInit {

  @Input() powerSupplyType: string = '';
  
  constructor(protected sanitizer: DomSanitizer) { }

  ngOnInit() {
  }
}
